<template>
    <div class="container  mt-3">
      <div class="m-auto">
          
        <div class="form-horizontal">
          <div class="form-group row" v-if="estudiante">
            <label class="col-12 col-sm-4 col-form-label">Enviar correos de Notificación</label>
            <div class="col-12 col-sm-4">
              <select v-model="enviar_notificaciones" class="form-control">
                <option disabled value="">Please select one</option>
                <option  value="1">SI</option>
                <option  value="0">NO</option>
              </select>
            </div>
            <div class="col-12 col-sm-4">
                <button v-if="procesable" class="btn btn-block btn-danger" @click="procesar">
                  Guardar
                </button>
              </div> 
          </div>
          <div v-else>
            No hay cursos inscritos
          </div>
          
        </div>
      </div>
    </div>
  </template>
  
  <script>
    import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
    
    export default {
      name: 'DetalleEnviarNotificacion',
      data () {
        return {
            enviar_notificaciones:null
        }
      },
      props: {
        estudiante: Object
      },
      mounted () {
        if(this.estudiante){
          this.enviar_notificaciones = this.estudiante.enviar_notificaciones
        }
      },
      methods:{
        ...mapActions({
            editarEnviarNotificacion: 'estudiantes/editarEnviarNotificacion',
            fetchDetalle: 'estudiantes/fetchDetalle',
            setWarning: 'setWarning',
        }),
        ...mapMutations({
          
        }),
        procesar(){
          this.editarEnviarNotificacion({
            id:this.estudiante.id,
            enviar_notificaciones:this.enviar_notificaciones,
            
          }).then((apiResponse)=>{
            
            this.limpiar()
            this.setWarning('Información Guardada', { root: true }).then(()=>{
              this.fetchDetalle(this.estudiante.id).then(()=>{
                this.$router.push('/estudiante/detalle/'+this.estudiante.id)
              }) 
            })
            
          }).catch((apiResponse)=>{
            console.log("error procesando editar notificacion.")
          })
        },
        limpiar(){
         this.enviar_notificaciones  = null
        }
      },
      computed:{
        ...mapState({
          
        }),
        ...mapGetters({
          
        }),
        procesable: {
          get () {
            return (this.enviar_notificaciones != null && this.enviar_notificaciones!=this.estudiante.enviar_notificaciones)
          },
          set(value){}
        },
      }
    }
  </script>
  
  <style scope>
    .programar_wrapper .form-container{
        
    }
      .programar_wrapper{
      
      }
  </style>
  
  